import { Navigate, Outlet } from 'react-router-dom';
import { useCanAll } from '@/shared/hooks/useCan';

type PermissionGuardProps = {
  required: string | string[];
  fallbackTo?: string;
};

/** Route-level permission gate for agency sub-accounts. */
export function PermissionGuard({
  required,
  fallbackTo = '/dashboard',
}: PermissionGuardProps) {
  const requiredList = Array.isArray(required) ? required : [required];
  const allowed = useCanAll(requiredList);

  if (!allowed) {
    return <Navigate to={fallbackTo} replace />;
  }

  return <Outlet />;
}
